import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import Util from "../../../../util/Util";
import CustomLabel from "../../../sub/CustomLabel";
import CrmSoftwareList from "../../../../enums/CrmSoftware";
import {
  updateCompanyCrm,
  deleteCompanyCrm,
} from "../../../../actions/clients/company/company";

class CompanyAddCrmConnect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      crm_software: undefined,
      endpoint: undefined,
      must_origin: undefined,
      login: undefined,
      password: undefined,
      must_declinaison: false,
      agence: null,
      usernameError: null,
      origineError: null,
      urlError: null,
      passwordError: null,
    };

    if (this.props.company) {
      var company = this.props.company;
      //var company = this.getCompany(company, this.props.company._id);

      if (company.crm !== undefined) {
        let credentials = company.crm.credentials;
        let options = company.crm.options;

        if (company.crm.software === CrmSoftwareList.Must) {
          this.state = {
            must_origin: options.must_origin,
            must_declinaison: options.must_declinaison,
            must_allow_sync_order_status: options.must_allow_sync_order_status,
          };
        } else if (company.crm.software === CrmSoftwareList.Lomaco) {
          this.state = {
            agence: options.lomaco.agence,
            allow_sync_order_status: options.lomaco.allow_sync_order_status,
          };
        }

        // Add common state values when crm is defined
        this.state = {
          ...this.state,
          crm_software: company.crm.software,
          endpoint: credentials.endpoint,
          login: credentials.login,
          password: credentials.password,
        };
      }

      // Add default crm endpoint urls
      this.state = {
        ...this.state,
        default_must_endpoint:
          "https://hb2.mustinformatique.fr:22443/APIWCF/orthop/",
        default_lomaco_endpoint: "https://fournisseurs.mycaelis.fr/",
      };
    }
  }

  isCrmSoftware(software) {
    return this.state.crm_software === software;
  }

  hasError() {
    return this.state.loginError || this.state.must_originError;
  }

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    let data = null;

    // No previous error
    if (this.hasError()) return;

    if (this.isCrmSoftware(CrmSoftwareList.Must)) {
      data = {
        company_id: this.props.company._id,
        software: this.state.crm_software,
        synced_with_crm: true,
        must_origin: this.state.must_origin,
        password: this.state.password,
        login: this.state.login,
        endpoint: this.state.endpoint,
        must_declinaison: this.state.must_declinaison,
        must_allow_sync_order_status: this.state.must_allow_sync_order_status,
      };
    } else if (this.isCrmSoftware(CrmSoftwareList.Lomaco)) {
      data = {
        company_id: this.props.company._id,
        software: this.state.crm_software,
        synced_with_crm: true,
        endpoint: this.state.endpoint,
        password: this.state.password,
        login: this.state.login,
        agence: this.state.agence,
        allow_sync_order_status: this.state.allow_sync_order_status,
      };
    } else {
      data = {
        company_id: this.props.company._id,
        synced_with_crm: false,
      };
    }

    // Send company information and redirect on success
    this.props.onUpdateCompanyCrm(
      data,
      () => this.props.close(),
      (e) => console.log(e),
    );
  }

  getCompany(companies, companyId) {
    for (let company of companies) {
      if (company.company_id === companyId) {
        return company;
      }
    }
  }

  hasEmptyField() {
    if (this.state.crm_software === CrmSoftwareList.Must) {
      return (
        !this.state.must_origin ||
        !this.state.login ||
        !this.state.password ||
        !this.state.endpoint
      );
    } else {
      return !this.state.login || !this.state.password || !this.state.endpoint;
    }
  }

  onChange(field, value) {
    this.setState({ [field]: value });
    // Check if company_name is not empty
    if (
      (field === "must_origin" || field === "password") &&
      !Util.emptyString(value)
    ) {
      this.setState({ originError: null });
      // Check if company_name < 50
      if (value.length > 50) {
        this.setState({
          originError: <FormattedMessage id="Character.Max" />,
        });
      }
    }

    // Check if email is not empty and not already taken
    if (field === "login" && !Util.emptyString(value)) {
      this.setState({ loginError: null });

      if (value.length > 20) {
        this.setState({
          loginError: <FormattedMessage id="Character.Max" />,
        });
      }
    }
  }

  updateProvider(e) {
    this.setState({ crm_software: e.target.value });

    if (e.target.value === CrmSoftwareList.Lomaco) {
      this.setState({ endpoint: this.state.default_lomaco_endpoint });
    }

    if (e.target.value === CrmSoftwareList.Must) {
      this.setState({ endpoint: this.state.default_must_endpoint });
    }
  }

  render() {
    let statusToBeDisplayed = Object.assign({}, CrmSoftwareList);
    let statusNode = Object.values(statusToBeDisplayed).map((option) => {
      return (
        <option key={option} value={option}>
          {option}
        </option>
      );
    });

    return (
      <div className="modal-body">
        <form onSubmit={(e) => this.handleSubmit(e)} autoComplete="off">
          <div className="form-group row">
            <div className="col-5">
              <CustomLabel
                label={this.props.intl.formatMessage({
                  id: "API.CRM.Provider",
                })}
                htmlFor="provider"
                required
              />
            </div>
            <div className="col">
              <select
                id="provider"
                className={"form-control"}
                onChange={(e) => this.updateProvider(e)}
                defaultValue={this.state.crm_software}
              >
                <option key="" value="">
                  {this.props.intl.formatMessage({
                    id: "Select",
                  })}
                </option>
                {statusNode}
              </select>
            </div>
          </div>
          {this.state.crm_software && (
            <>
              <div className="form-group row">
                <div className="col-5">
                  <CustomLabel
                    label={this.props.intl.formatMessage({ id: "URL" })}
                    htmlFor="endpoint"
                    labelClassName="col-5"
                    required
                  />
                </div>
                <div className="col-7">
                  <input
                    type="text"
                    id="endpoint"
                    name="endpoint"
                    disabled={
                      this.state.crm_software === CrmSoftwareList.Lomaco
                    }
                    className="form-control"
                    value={
                      this.state.crm_software === CrmSoftwareList.Lomaco
                        ? this.state.default_lomaco_endpoint
                        : this.state.endpoint
                    }
                    onChange={(e) =>
                      this.onChange("endpoint", "" + e.target.value)
                    }
                  />
                  <small className="text-danger">{this.state.urlError}</small>
                </div>
              </div>

              <div className="form-group row">
                <div className="col-5">
                  <CustomLabel
                    label={this.props.intl.formatMessage({ id: "Username" })}
                    htmlFor="login"
                    labelClassName="col-5"
                    required
                  />
                </div>
                <div className="col-7">
                  <input
                    type="text"
                    id="login"
                    name="login"
                    className="form-control"
                    defaultValue={this.state.login}
                    onChange={(e) =>
                      this.onChange("login", "" + e.target.value)
                    }
                  />
                  <small className="text-danger">
                    {this.state.usernameError}
                  </small>
                </div>
              </div>
              <div className="form-group row">
                <div className="col-5">
                  <CustomLabel
                    label={this.props.intl.formatMessage({ id: "Password" })}
                    htmlFor="password"
                    labelClassName="col-5"
                    required
                  />
                </div>
                <div className="col-7">
                  {/** https://stackoverflow.com/questions/54970352/input-elements-should-have-autocomplete-attributes **/}
                  <input
                    type="password"
                    id="password"
                    name="password"
                    className="form-control"
                    defaultValue={this.state.password ? "*******" : ""}
                    onChange={(e) =>
                      this.onChange("password", "" + e.target.value)
                    }
                    autoComplete="off"
                  />
                  <small className="text-danger">
                    {this.state.passwordError}
                  </small>
                </div>
              </div>
            </>
          )}
          {this.state.crm_software &&
            this.isCrmSoftware(CrmSoftwareList.Must) && (
              <>
                <div className="form-group row">
                  <div className="col-5">
                    <CustomLabel
                      label={this.props.intl.formatMessage({ id: "Origin" })}
                      htmlFor="origine"
                      labelClassName="col-5"
                      required
                    />
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      id="origine"
                      name="origine"
                      className="form-control"
                      defaultValue={this.state.must_origin}
                      onChange={(e) =>
                        this.onChange("must_origin", "" + e.target.value)
                      }
                    />
                    <small className="text-danger">
                      {this.state.origineError}
                    </small>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-11">
                    <CustomLabel
                      label={this.props.intl.formatMessage({
                        id: "API.CRM.Use.Declinaison",
                      })}
                      htmlFor="must_declinaison"
                    />
                  </div>
                  <div className="col form-check text-right">
                    <input
                      type="checkbox"
                      id="must_declinaison"
                      name="must_declinaison"
                      className="form-check-input"
                      defaultChecked={this.state.must_declinaison}
                      onChange={() =>
                        this.onChange(
                          "must_declinaison",
                          !this.state.must_declinaison,
                        )
                      }
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-11">
                    <CustomLabel
                      label={this.props.intl.formatMessage({
                        id: "API.CRM.Allow.Order.Status.Sync.Function",
                      })}
                      htmlFor="must_allow_sync_order_status"
                    />
                  </div>
                  <div className="col form-check text-right">
                    <input
                      type="checkbox"
                      id="must_allow_sync_order_status"
                      name="must_allow_sync_order_status"
                      className="form-check-input"
                      defaultChecked={this.state.must_allow_sync_order_status}
                      onChange={() =>
                        this.onChange(
                          "must_allow_sync_order_status",
                          !this.state.must_allow_sync_order_status,
                        )
                      }
                    />
                  </div>
                </div>
              </>
            )}
          {this.state.crm_software &&
            this.isCrmSoftware(CrmSoftwareList.Lomaco) &&
            this.state.agence !== null && (
              <>
                <div className="form-group row">
                  <div className="col-5">
                    <CustomLabel
                      label={this.props.intl.formatMessage({ id: "Agency" })}
                      htmlFor="agence"
                      labelClassName="col-5"
                      required
                    />
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      id="agence"
                      name="agence"
                      className="form-control"
                      defaultValue={
                        this.state.agence ? this.state.agence.name : ""
                      }
                      onChange={(e) =>
                        this.onChange("agence", "" + e.target.value)
                      }
                      disabled
                    />
                    <small className="text-danger">
                      {this.state.usernameError}
                    </small>
                  </div>
                </div>
                <div className="form-group row">
                  <CustomLabel
                    label={this.props.intl.formatMessage({
                      id: "API.CRM.Allow.Order.Status.Sync.Function",
                    })}
                    htmlFor="allow_sync_order_status"
                    labelClassName="col-7 col-form-label"
                  />
                  <div className="form-check col-5">
                    <input
                      type="checkbox"
                      id="allow_sync_order_status"
                      name="allow_sync_order_status"
                      className="form-check-input"
                      defaultChecked={this.state.allow_sync_order_status}
                      onChange={() =>
                        this.onChange(
                          "allow_sync_order_status",
                          !this.state.allow_sync_order_status,
                        )
                      }
                    />
                  </div>
                </div>
              </>
            )}
          <div className="row mt-4">
            <div className="col-4 m-auto d-flex">
              <button
                type="submit"
                disabled={
                  this.hasEmptyField() ||
                  (this.isCrmSoftware(CrmSoftwareList.Must) &&
                    !this.state.must_origin) ||
                  this.state.origineError ||
                  this.state.usernameError ||
                  this.state.passwordError ||
                  this.state.urlError
                }
                className="m-1 h-50 btn btn-info btn-block button-info right"
              >
                <FormattedMessage id="Edit" />
              </button>
              <button
                disabled={
                  this.isCrmSoftware(CrmSoftwareList.Must) &&
                  !this.state.must_origin &&
                  !this.state.login &&
                  !this.state.password &&
                  !this.state.endpoint
                }
                className="m-1 btn btn-danger btn-block button-info right"
                onClick={() => {
                  let title = <FormattedMessage id="Warning" />;
                  let content = (
                    <FormattedMessage id="Remove.CRM.Confirmation" />
                  );
                  let successCallback = () => {
                    this.props.onDeleteCompanyCrm(
                      { companyId: this.props.company._id },
                      () => this.props.close(),
                    );
                  };
                  this.props.openConfModal(title, content, successCallback);
                }}
              >
                <FormattedMessage id="Delete" />
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onDeleteCompanyCrm: (data, successCallback) =>
      dispatch(deleteCompanyCrm(data, successCallback)),
    onUpdateCompanyCrm: (data, successCallback, failureCallback) =>
      dispatch(updateCompanyCrm(data, successCallback, failureCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyAddCrmConnect));
